import { CSSProperties, ReactNode } from 'react'
import { faCalculator } from '@fortawesome/pro-regular-svg-icons'
import { Alert, Icon } from '@/componentsV1/BaseComponents'

export const CalculationAlert = ({
  children,
  contentStyle,
  innerTextStyle,
}: {
  children: ReactNode
  contentStyle?: CSSProperties
  innerTextStyle?: CSSProperties
}) => (
  <Alert
    contentStyle={contentStyle}
    innerTextStyle={innerTextStyle}
    customIcon={<Icon icon={faCalculator} />}
  >
    {children}
  </Alert>
)
